import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { 
  Image, 
  Plus,
  Edit,
  Trash2,
  Upload
} from 'lucide-react';
import { toast } from 'sonner';

const AdminGalleryPage = () => {
  const [clients, setClients] = useState([
    { id: '1', name: 'TechCorp', logo: '', active: true },
    { id: '2', name: 'FinanceHub', logo: '', active: true },
    { id: '3', name: 'SportMax', logo: '', active: true },
    { id: '4', name: 'FoodLab', logo: '', active: false },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Galerie clients</h1>
          <p className="text-[#64748b]">Logos de vos clients de confiance</p>
        </div>
        <Button className="bg-amber-600 hover:bg-amber-700">
          <Plus className="w-4 h-4 mr-2" />
          Ajouter un logo
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {clients.map((client) => (
          <Card key={client.id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <div className="aspect-square bg-slate-50 rounded-lg flex items-center justify-center mb-3 relative group">
                {client.logo ? (
                  <img src={client.logo} alt={client.name} className="max-w-full max-h-full object-contain p-2" />
                ) : (
                  <Image className="w-8 h-8 text-slate-300" />
                )}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center gap-2">
                  <Button variant="secondary" size="icon" className="h-8 w-8">
                    <Upload className="w-4 h-4" />
                  </Button>
                  <Button variant="destructive" size="icon" className="h-8 w-8">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
              <p className="text-sm font-medium text-center text-[#1a365d]">{client.name}</p>
              <p className="text-xs text-center text-[#64748b]">{client.active ? 'Actif' : 'Inactif'}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminGalleryPage;
